import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import {
  ChapterItemType,
  ModuleItemType,
  QuestionsItemType,
} from '../types/module'

interface ModulesState {
  modules: {
    selectedChapter: ChapterItemType | null
    selectedModule: ModuleItemType | null
    selectedQuestion: QuestionsItemType | null
    items: ModuleItemType[]
    setItems: (items: ModuleItemType[]) => void
    setSelectedModule: (item: ModuleItemType) => void
    setSelectedChapter: (item: ChapterItemType) => void
    setSelectedQuestion: (item: QuestionsItemType) => void
    clear: () => void
  }
}

export const useModules = create<ModulesState>()(
  persist(
    (set) => ({
      modules: {
        selectedQuestion: null,
        selectedChapter: null,
        selectedModule: null,
        items: [],
        setItems: (items) =>
          set((state) => ({ ...state, modules: { ...state.modules, items } })),
        setSelectedModule: (item) =>
          set((state) => ({
            ...state,
            modules: { ...state.modules, selectedModule: item },
          })),
        setSelectedChapter: (item) =>
          set((state) => ({
            ...state,
            modules: { ...state.modules, selectedChapter: item },
          })),
        setSelectedQuestion: (item) =>
          set((state) => ({
            ...state,
            modules: { ...state.modules, selectedQuestion: item },
          })),
        clear: () =>
          set((state) => ({
            ...state,
            modules: { ...state.modules, items: [] },
          })),
      },
    }),
    {
      name: 'modules-store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        modules: {
          items: state.modules.items,
          selectedModule: state.modules.selectedModule,
          selectedChapter: state.modules.selectedChapter,
          selectedQuestion: state.modules.selectedQuestion,
        },
      }),
      merge: (persistedState, currentState) => {
        const persisted = persistedState as Partial<ModulesState>
        return {
          ...currentState,
          modules: {
            ...currentState.modules,
            ...(persisted.modules ?? {}),
          },
        }
      },
    }
  )
)

export const useModulesStore = () => useModules((state) => state.modules)
